import { useQuery } from "@tanstack/react-query";
import { getExpenseConsolidatedByPlate } from "../services";
import type {
	ExpenseConsolidatedByPlateFilters,
	ExpenseConsolidatedByPlatePaginatedResponse,
} from "../types";

const initialData: ExpenseConsolidatedByPlatePaginatedResponse = {
	filter: {
		startDate: "",
		endDate: "",
		days: 0,
		selectedVehiclesCount: 0,
	},
	items: {
		items: [],
		totalCount: 0,
		pageSize: 10,
		currentPage: 1,
		totalPages: 1,
	},
};

export function useGetExpenseConsolidatedByPlate(
	filters: ExpenseConsolidatedByPlateFilters
) {
	return useQuery({
		queryKey: ["expenses", "consolidated", "plate", filters],
		queryFn: () => getExpenseConsolidatedByPlate(filters),
		initialData,
		enabled: !!filters.startDate && !!filters.endDate,
	});
}
